import  "babel-polyfill"
import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/es/map';
import 'core-js/es/set';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import reduce from "./reducers";
import {createStore, applyMiddleware} from "redux";
import thunk from 'redux-thunk';
import Router from "./route";
import {ConfigProvider} from "antd";
import zhCN from "antd/es/locale/zh_CN";
import  "react-app-polyfill/ie11";
import  "react-app-polyfill/stable";

let store = createStore(reduce, applyMiddleware(thunk));

ReactDOM.render(<Provider store={store}>
    <ConfigProvider locale={zhCN}>
        <Router/>
    </ConfigProvider>
</Provider>, document.getElementById('root'));

serviceWorker.unregister();

